import { useEffect, useState } from "react";

const widthFromHeight = (height, aspect) => {
  if (!aspect || typeof height !== "string") return "auto";
  const m = /^([\d.]+)(.*)$/.exec(height.trim());
  if (!m) return "auto";
  return `${(parseFloat(m[1]) * aspect).toFixed(3)}${m[2] || "px"}`;
};

export const PixelSprite = ({ params, walking = false, facing = "right", height = "30em", style, className = "", testId }) => {
  const frames = params?.frames || [];
  const animated = walking && frames.length > 1;
  const [frame, setFrame] = useState(0);

  const src = frames[frame] || frames[0];
  const key = frames[0] || "";

  useEffect(() => {
    setFrame(0);
    if (!animated) return undefined;
    const id = setInterval(() => setFrame((f) => (f + 1) % frames.length), 240);
    return () => clearInterval(id);
  }, [animated, key, frames.length]);

  const flip = facing === "left" ? "scaleX(-1) " : "";
  const bob = animated && frame % 2 === 1 ? " translateY(-1.4%)" : "";
  const width = widthFromHeight(height, params?.aspect);

  return (
    <img
      src={src}
      alt=""
      draggable={false}
      data-testid={testId}
      className={`sprite-img ${className}`}
      style={{ height, width, transform: `${flip}${bob}`, ...style }}
    />
  );
};
